// NUEVO CON COMPONENTES CAMERA
import React, { useEffect, useState, useCallback } from 'react';
import { FaBus, FaGift, FaFileInvoice, FaVideo, FaFileImport, FaFileExport, FaFileAlt, FaMapMarkedAlt } from 'react-icons/fa';
import { BeatLoader } from 'react-spinners';
import CustomNavbar from '../components/Navbar';
import EmployeeCard from '../components/Card';
import PendingTasksCard from '../components/PendingTasksCard';
import PoliticaVisionCard from '../components/PoliticaVisionCard';
import OrganigramaCard from '../components/OrganigramaCard';
import { Container, Row, Col, Alert, Tabs, Tab, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import BubbleButton from '../components/BubbleButton'
import 'react-toastify/dist/ReactToastify.css';
import '../styles/home.css';
import TalleModalButton from '../components/TalleModalButton';
import { usePermisos } from '../hooks/usePermisos';
import { openHeatmap, HEATMAP_CONFIG, HEATMAP_PERMISSION } from '../config/heatmap.config';

// En desarrollo usar backend local, en producción usar proxy
const API_URL = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:4004' 
  : '';

const Init = () => {
  const [userData, setUserData] = useState(null);
  const [token, setToken] = useState(null);
  const [recibos, setRecibos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('recibos');
  const [informePendiente, setInformePendiente] = useState(null);
  const navigate = useNavigate();
  
  // Usar nuevo sistema de permisos
  const { tienePermiso, permisos, loading: permisosLoading } = usePermisos();
  
  console.log('🏠 Init - Estado de permisos:');
  console.log('  - Loading:', permisosLoading);
  console.log('  - Permisos array:', permisos);
  console.log('  - tienePermiso function:', typeof tienePermiso);
  console.log('🔑 Verificando permisos individuales:');
  console.log('  - CARGAINF:', tienePermiso('CARGAINF'));
  console.log('  - VERDIAG:', tienePermiso('VERDIAG'));
  console.log('  - VERINF:', tienePermiso('VERINF'));
  console.log('  - VERINFCONF:', tienePermiso('VERINFCONF'));
  console.log('  - INFOPEN:', tienePermiso('INFOPEN'));

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const storedToken = localStorage.getItem('token');

    if (!storedUser || !storedToken) {
      navigate('/');
      return;
    }

    setUserData(JSON.parse(storedUser));
    setToken(storedToken);
    
    // Obtener CUIL del empleado si no está en los datos guardados
    const fetchCUIL = async () => {
      try {
        const parsedUser = JSON.parse(storedUser);
        if (!parsedUser.CUIL && parsedUser.Legajo) {
          const response = await fetch(`${API_URL}/api/empleados/${parsedUser.Legajo}`, {
            headers: {
              'Authorization': `Bearer ${storedToken}`,
              'Content-Type': 'application/json'
            }
          });
          
          if (response.ok) {
            const empleado = await response.json();
            const updatedUser = { ...parsedUser, CUIL: empleado.CUIL };
            setUserData(updatedUser);
            localStorage.setItem('user', JSON.stringify(updatedUser));
          }
        }
      } catch (error) {
        console.error('Error obteniendo CUIL:', error);
      }
    };
    
    fetchCUIL();
  }, [navigate]);

  const fetchRecibos = useCallback(async () => {
    if (!userData || !token) {
      setError('No se encontraron datos del usuario o token.');
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const response = await fetch(
        `${API_URL}/api/recibos/mis-recibos`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 401) {
        console.error('Token inválido o expirado');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/');
        return;
      }

      if (!response.ok) {
        throw new Error(`Error al obtener recibos: ${response.statusText} (${response.status})`);
      }

      const data = await response.json();
      setRecibos(data.data || data);
    } catch (err) {
      console.error('Error fetching recibos:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [userData, token, navigate]);

  useEffect(() => {
    if (userData && token) {
      fetchRecibos();
    }
  }, [userData, token, fetchRecibos]);

  const handleDocumentsComplete = (result) => {
    // Documentos completados
  };

  const handleNavigate = (path) => {
    navigate(path);
  };

  if (loading || permisosLoading) {
    return (
      <div className="loading-container">
        <div className="bus-loading">
          <FaBus className="pink-bus-icon" />
          <BeatLoader color="#ff00b3" size={15} />
        </div>
      </div>
    );
  }

  // ==================== VERSIÓN v1.0 (Bootstrap - Original) ====================
  return (
    <div className="init-container">
      <CustomNavbar userData={userData} />
      
      <Container className="main-content py-4">
        <Row className="justify-content-center mb-4">
          <Col xs={12} className="text-center">
            <div className='title_init'>
              <h2 className='welc'>Bienvenido a</h2>
              <h2 className='color_empresa'> SiBus</h2>
            </div>
          </Col>
        </Row>

        {/* Card de Política y Visión */}
        <Row className="justify-content-center mb-4">
          <Col xs={12} lg={10}>
            {userData && <PoliticaVisionCard userData={userData} />}
          </Col>
        </Row>

        {/* Card de Organigrama */}
        <Row className="justify-content-center mb-4">
          <Col xs={12} lg={10}>
            {userData && <OrganigramaCard userData={userData} />}
          </Col>
        </Row>

        {/* Cards de información del usuario */}
        <Row className="justify-content-center mb-4">
          <Col xs={12} lg={6} className="mb-3">
            {userData && <EmployeeCard userData={userData} />}
          </Col>
          {/* PENDIENTES DEL USUARIO */}
          <Col xs={12} lg={6} className="mb-3">
            {userData && <PendingTasksCard userData={userData} />}
          </Col>
        </Row>

        {/* Grid de módulos - Accesos rápidos */}
        <Row className="justify-content-center mb-4">
          {/* BENEFICIOS */}
          <Col xs={12} md={6} lg={4} className="mb-3">
            <Card className="option-card" onClick={() => handleNavigate('/home/beneficios')}>
              <Card.Body className="d-flex align-items-center">
                <FaGift size={30} className="me-3" style={{ color: '#ff00b3' }} />
                <h5 className="mb-0">Beneficios</h5>
              </Card.Body>
            </Card>
          </Col>

          {/* CAPACITACIONES */}
          <Col xs={12} md={6} lg={4} className="mb-3">
            <Card className="option-card" onClick={() => handleNavigate('/home/ver-capacitaciones')}>
              <Card.Body className="d-flex align-items-center">
                <FaVideo size={30} className="me-3" style={{ color: '#0066ff' }} />
                <h5 className="mb-0">Capacitaciones</h5>
              </Card.Body>
            </Card>
          </Col>

          {/* RECIBOS */}
          <Col xs={12} md={6} lg={4} className="mb-3">
            <Card className="option-card" onClick={() => handleNavigate('/home/recibos')}>
              <Card.Body className="d-flex align-items-center">
                <FaFileInvoice size={30} className="me-3" style={{ color: '#ff00b3' }} />
                <h5 className="mb-0">Recibos</h5>
              </Card.Body>
            </Card>
          </Col>

          {/* RESPONDER INFORME */}
          {informePendiente && (
            <Col xs={12} md={6} lg={4} className="mb-3">
              <Card className="option-card" onClick={() => handleNavigate(`/home/descargo/${informePendiente.id}`)}>
                <Card.Body className="d-flex align-items-center">
                  <FaFileImport size={30} className="me-3" color='orange' />
                  <h5 className="mb-0">Responder Informe</h5>
                </Card.Body>
              </Card>
            </Col>
          )}

          {/* CARGAR INFORME*/}
          {tienePermiso('CARGAINF') && (
            <Col xs={12} md={6} lg={4} className="mb-3">
              <Card className="option-card" onClick={() => handleNavigate('/home/informes')}>
                <Card.Body className="d-flex align-items-center">
                  <FaFileExport size={30} className="me-3" style={{ color: '#ff00b3' }} />
                  <h5 className="mb-0">Generar Informe</h5>
                </Card.Body>
              </Card>
            </Col>
          )}

          {/* VER INFORMES PENDIENTES (ENCARGADO/INSPECTOR) */}
          {tienePermiso('INFOPEN') && (
            <Col xs={12} md={6} lg={4} className="mb-3">
              <Card className="option-card" onClick={() => handleNavigate('/home/ver-informes-encargado')}>
                <Card.Body className="d-flex align-items-center">
                  <FaFileImport size={30} className="me-3" color='darkorange' />
                  <h5 className="mb-0">Informes Pendientes</h5>
                </Card.Body>
              </Card>
            </Col>
          )}

          {/* VER INFORMES */}
          {tienePermiso('VERINF') && (
            <Col xs={12} md={6} lg={4} className="mb-3">
              <Card className="option-card" onClick={() => handleNavigate('/home/ver-informes-devueltos')}>
                <Card.Body className="d-flex align-items-center">
                  <FaFileExport size={30} className="me-3" style={{ color: '#ff00b3' }} />
                  <h5 className="mb-0">Ver Informes</h5>
                </Card.Body>
              </Card>
            </Col>
          )}

          {/* VER INFORMES CONFIRMADOS */}
          {tienePermiso('VERINFCONF') && (
            <Col xs={12} md={6} lg={4} className="mb-3">
              <Card className="option-card" onClick={() => handleNavigate('/home/ver-informes-confirmados')}>
                <Card.Body className="d-flex align-items-center">
                  <FaFileImport size={30} className="me-3" style={{ color: '#ff00b3' }} />
                  <h5 className="mb-0">Informes</h5>
                </Card.Body>
              </Card>
            </Col>
          )}

          {/* VER DIAGRAMAS DE INSPECCIÓN (Solo visualización) */}
          {tienePermiso('VERDIAG') && (
            <Col xs={12} md={6} lg={4} className="mb-3">
              <Card className="option-card" onClick={() => handleNavigate('/home/mis-diagramas')}>
                <Card.Body className="d-flex align-items-center">
                  <FaFileAlt size={30} className="me-3" style={{ color: '#ff00b3' }} />
                  <h5 className="mb-0">Mis Diagramas</h5>
                </Card.Body>
              </Card>
            </Col>
          )}

          {/* MAPA DE CALOR */}
          {tienePermiso(HEATMAP_PERMISSION) && (
            <Col xs={12} md={6} lg={4} className="mb-3">
              <Card 
                className="option-card heatmap-card" 
                onClick={() => openHeatmap()}
                style={{ 
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  border: 'none',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
                }}
              >
                <Card.Body className="d-flex flex-column justify-content-center" style={{ minHeight: '120px' }}>
                  <div className="d-flex align-items-center mb-2">
                    <FaMapMarkedAlt size={32} className="me-3" style={{ color: '#ffffff' }} />
                    <h5 className="mb-0" style={{ color: '#ffffff', fontWeight: '600' }}>
                      {HEATMAP_CONFIG.title}
                    </h5>
                  </div>
                  <p className="mb-0" style={{ 
                    color: 'rgba(255,255,255,0.9)', 
                    fontSize: '0.875rem',
                    marginLeft: '44px' 
                  }}>
                    {HEATMAP_CONFIG.subtitle}
                  </p>
                </Card.Body>
              </Card>
            </Col>
          )}
        </Row>

        {error && (
          <Row className="mb-4">
            <Col xs={12}>
              <Alert variant="danger" className="text-center">
                {error}
              </Alert>
            </Col>
          </Row>
        )}

        {!error && (
          <>
            <Tabs
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
              className="mb-3 custom-tabs"
            >
            </Tabs>
          </>
        )}
        
      </Container>
      <div className="floating-buttons">
        <TalleModalButton user={userData} />
      </div>
    </div>
  );
};

export default Init;
